import {EditDetailsSectionButtons} from '@/components/commons/edit-details-section-buttons/EditDetailsSectionButtons'
import {DetailsFieldsSection} from '@/components/ui/details-atoms/DetailsAtoms'
import {ProjectPathologiesDetailsContent} from '@/features/projects/components/project-pathologies-details-content/ProjectPathologiesDetailsContent'
import {ProjectPathology} from '@/features/projects/types'
import {useOutletContext} from 'react-router-dom'

interface ProjectPathologiesDetailsProps {
    pathologies?: (Omit<ProjectPathology, 'startedAt'> & {startedAt?: string})[]
    isDisabled: boolean
    isLoading: boolean
    isActive: boolean
    isError: boolean
    title: string
    showStartDate?: boolean
    handleCancel: () => void
    handleEdit: () => void
    isMainPathologies?: boolean
}

export const ProjectPathologiesDetails = ({
    isDisabled,
    isLoading,
    isActive,
    isError,
    title,
    handleCancel,
    pathologies,
    handleEdit,
    showStartDate,
    isMainPathologies
}: ProjectPathologiesDetailsProps) => {
    const {isEditable} = useOutletContext<{isEditable: boolean}>()

    return (
        <DetailsFieldsSection
            variant="neutral"
            title={title}
            isDisabled={isDisabled}
            headingEndSlot={
                isEditable && (
                    <EditDetailsSectionButtons
                        isLoading={isLoading}
                        isActive={isActive}
                        onCancel={handleCancel}
                        onEdit={handleEdit}
                    />
                )
            }
        >
            <ProjectPathologiesDetailsContent
                pathologies={pathologies}
                isLoading={isLoading}
                isError={isError}
                showStartDate={showStartDate}
                isMainPathologies={isMainPathologies}
            />
        </DetailsFieldsSection>
    )
}
